"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotifyingSettings = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../CheckBox");
require("./index.scss");
class NotifyingSettings extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.handleFormCheckboxInputChange = (event) => {
            const { name, checked } = event.target;
            this.props.onChange({ ...this.props.notifying, [name]: checked });
        };
    }
    render() {
        const className = 'notifying-settings';
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement("div", { className: `${className}__checkbox` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/NotifyingSettings:isEmailNotifyEnabled', defaultMessage: 'Email' }), onChange: this.handleFormCheckboxInputChange, checked: this.props.notifying.isEmailNotifyEnabled, name: 'isEmailNotifyEnabled' })))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement("div", { className: `${className}__checkbox` },
                        react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/NotifyingSettings:isSmsNotifyEnabled', defaultMessage: 'SMS' }), onChange: this.handleFormCheckboxInputChange, checked: this.props.notifying.isSmsNotifyEnabled, name: 'isSmsNotifyEnabled' }))))));
    }
}
exports.NotifyingSettings = NotifyingSettings;
NotifyingSettings.defaultProps = {
    onChange: () => { },
};
//# sourceMappingURL=index.js.map